import React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import { useSelector } from "react-redux";

const Header = () => {
    const sitename = useSelector(state => state.website.sitename)

    return (
        <React.Fragment>
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static" color="primary">
                    <Toolbar>
                        <LiveTvIcon fontSize="medium" />
                        <Typography variant="h6" component="div" sx={{ pl: 1 }}>
                            {sitename}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
        </React.Fragment>
    )
}

export default Header;
